import Scene = Phaser.Scene;
import {Sizes} from "@/constants/size";
import {Keys} from "@/constants/key";
import {Creature} from "@/store/level/types";
import Image = Phaser.GameObjects.Image;
import AtlasUtils from "@/utils/atlas-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import SContainer from "@/cmp/s-container";
import {PositionedContainer} from "@/scenes.ui/positioned-container";

export default class SimplifiedCreaturePanel extends SContainer implements PositionedContainer {

    private mainImage: Image | undefined;

    private cardShade!: Image;

    private originalX: number;
    private originalY: number;

    constructor(scene: Scene, x: number, y: number, c: Creature) {
        super(scene, x, y);

        this.originalX = x;
        this.originalY = y;

        this.setSize(Sizes.CELL_WIDTH, Sizes.CELL_HEIGHT);

        this.cardShade = SpriteUtils.addImage(this.scene, -38 / CU.S, 28 / CU.S, Keys.IMG_CARD_SHADE, 1 / CU.S, 1 / CU.S)
            .setVisible(false);

        if (Keys.ADDITIONAL_CREATURES.includes(c.imageId)) {
            this.mainImage = SpriteUtils.addImage(this.scene, 0, 0, Keys.battleCreature(c.imageId), undefined, 1 / CU.S, 1 / CU.S);
        } else {
            this.mainImage = SpriteUtils.addImage(this.scene, 0, 0, AtlasUtils.getCreatureBattleAtlas(c.imageId), c.imageId, 1 / CU.S, 1 / CU.S);
        }

        this.add([this.cardShade, this.mainImage]);
    }

    public setScale(x: number, y?: number): this {
        return super.setScale(x, y ? y : 1);
    }

    public getCardShade() {
        return this.cardShade;
    }

    public setCardShadeVisible() {
        this.cardShade.setVisible(true);
    }

    public getOriginalX(): number {
        return this.originalX;
    }

    public getOriginalY(): number {
        return this.originalY;
    }
}

